import { useEffect, useState } from 'react';
import { fetchBackendBuildInfo } from '@/apis/build';
import type { BuildInfo } from '@/common/buildInfo';
import './style.less';

const formatTime = (v: string) => {
  if (!v) return '';
  // '2026-08-19T17:34:17+08:00' / '2026-08-19T09:41:33.761Z' → 本地 'YYYY-MM-DD HH:mm:ss'
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
    + `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

interface Props {
  collapsed: boolean;
}

/**
 * 侧边栏底部收起按钮下方展示的后端「更新时间」。
 * - 只在展开状态显示;收起状态返回 null。
 * - 完整前后端构建信息见「系统 / 关于」子页面。
 */
const BuildBadge = ({ collapsed }: Props) => {
  const [backend, setBackend] = useState<BuildInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchBackendBuildInfo().then((info) => {
      if (!cancelled) setBackend(info);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (collapsed || !backend) return null;
  const t = formatTime(backend.buildTime);
  if (!t) return null;

  return <div className="build-badge">打包时间: {t}</div>;
};

export default BuildBadge;
